import React, { Fragment, useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { uiLogin } from "./../../Utils/actions/auth";
import "./Login.scss";
import { getValidateKey } from "../../Utils/actions";
import { loadingOn } from "../../Utils/utils";
// import background from "../../Assets/Images/bgLicense.jpg";
import background from "../../Assets/Images/BG2.jpg";
// import background from "../../Assets/Images/veras.jpg";
// import background from "../../Assets/Images/verasBG.png";
import "../../App.css";
import { errorMsg } from "../../Utils/errorMsg/ErrorMsg";
import smallLogo from "../../Assets/Images/verasLogo.png";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment"; // Needed for proper adornment positioning in MUI TextField
import LoginIcon from '@mui/icons-material/Login';

const Login = () => {
  const { isValidKey } = useSelector((state) => state.data);
  const { username, pass } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const [user, setUsername] = useState(username);
  const [password, setPassword] = useState(pass);
  // const [rememberMe, setRememberMe] = useState(false)
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem("rememberMe") === "true"
  );
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    localStorage.setItem("rememberMe", rememberMe.toString());
  }, [rememberMe]);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPassword = localStorage.getItem("password");
    const storedRememberMe = localStorage.getItem("rememberMe") === "true";

    if (storedUsername && storedPassword) {
      setUsername(storedUsername);
      setPassword(storedPassword);
      setRememberMe(storedRememberMe);
    }
  }, []);

  const addToSession = () => {
    localStorage.setItem("username", user);
    localStorage.setItem("password", password);
  };

  const handleLogin = async (e) => {
    if (rememberMe) {
      addToSession();
    }
    if (!user || !password) {
      errorMsg("Please enter both username and password");
      return;
    }
    (await isValidKey)
      ? e.target.value === "generate"
        ? document.location.replace("/veras/#/validForm")
        : dispatch(uiLogin({ user, password }))
      : document.location.replace("/veras/#/validForm");
  };

  useEffect(() => {
    dispatch(loadingOn());
    dispatch(getValidateKey());
  }, []);

  const handleKeypress = (e) => {
    if (e.charCode === 13) {
      handleLogin({ target: { value: "login" } });
    }
  };

  const handleRememberMe = (e) => {
    const isChecked = e.target.checked;
    setRememberMe(isChecked);
    localStorage.setItem("rememberMe", isChecked.toString());
    // console.log("Remember me checked:", isChecked);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div style={{ height: "100vh" }}>
        <div
          className=" w-100 login-page"
          style={{
            // backgroundImage: `url(${background})`,
            backgroundImage: `linear-gradient(rgba(10, 10, 10, 0.8), rgba(10, 10, 10, 0.8)), url(${background})`,
            // backgroundImage: `url(${background})`,
            backgroundSize: "100vw 100vh",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <Card
            className="mx-auto login-card shadow-none"
            style={{
              backgroundColor: "#c7c7c7",
              color: "#fff",
              height: "320px",
              width: "320px",
              // border: "none",
            }}
          >
            <Card.Header
              className="cardHeader shadow-none"
              style={{
                padding: "5px 10px",
                background: "linear-gradient(135deg, #0e0e0e, #555555)",
                transition: "background 0.3s ease, transform 0.2s ease",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <img
                className={"bc-logo"}
                src={smallLogo}
                height={50}
                alt={"logo"}
              />

              {/* <strong style={{ fontSize: "18px" }}>Login</strong> */}
            </Card.Header>
            <Card.Body
              style={{
                backgroundColor: "#c7c7c7",
                color: "#fff",
                display: "block",
                position: "relative",
                height: "100vh",
              }}
            >
              <div className="col-md-12 m-0 p-0">
                <Form.Group>
                  <Form.Label style={{ color: "#000" }}>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Username"
                    value={user}
                    onChange={(e) => setUsername(e.target.value)}
                    className="formText"
                    // style={{borderColor: '#286685'}}
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 m-0 p-0" style={{ marginTop: "15px" }}>
                <Form.Group>
                  <Form.Label style={{ color: "#000" }}>Password</Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={(e) => handleKeypress(e)}
                      // Add padding-right to the input to prevent text from going under the icon
                      style={{ paddingRight: "40px" }}
                    />
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={togglePasswordVisibility}
                      edge="end"
                      style={{
                        position: "absolute",
                        right: "10px", // Adjust as needed
                        top: "50%",
                        transform: "translateY(-50%)",
                        // color: "inherit", // Inherit color from parent or set a specific color
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </div>
                </Form.Group>
              </div>
              <div
                className="col-md-12 p-0 m-0"
                style={{
                  position: "relative",
                  alignItems: "center",
                  top: "10px",
                }}
              >
                <Form.Group>
                  <Form.Check
                    inline
                    label="Remember me?"
                    name="rememberMe"
                    // value={rememberMe}
                    checked={rememberMe}
                    type={"checkbox"}
                    id={`inline-checkbox-1`}
                    onChange={handleRememberMe}
                    style={{ color: "black" }}
                  />
                </Form.Group>
              </div>
            </Card.Body>
            {/* <Card.Footer className="shadow-none d-flex align-content-between justify-content-between" style={{ backgroundColor: '#367599', color: '#fff', border: 'none' }}>
                        <div className="col-md-12 m-0 p-0 d-flex">
                            <div className="col-md-6 col-sm-12">
                                <Button block onClick={(e) => handleLogin(e)} value={'generate'} style={{ backgroundColor: '#fff', color: '#286685', fontWeight: '800', border: 'transparent', boxShadow: 'none', }}>
                                    {"Generate Key"}
                                </Button>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <Button block onClick={(e) => handleLogin(e)} value={'login'} style={{ backgroundColor: '#fff', color: '#286685', fontWeight: '800', border: 'transparent', boxShadow: 'none' }}>
                                    {"Login"}
                                </Button>
                            </div>
                        </div>
                    </Card.Footer> */}
            <Card.Footer
              className="shadow-none p-0 m-0 d-flex align-content-between justify-content-between"
              style={{
                backgroundColor: "#white",
                color: "#fff",
                border: "none",
              }}
            >
              <div className="col-md-12 m-0 p-0 my-4 d-flex">
                {/* <div className="col-md-6  mb-2 mb-md-0 btnclass">
                                <Button block onClick={(e) => handleLogin(e)} className="btns" value={'generate'}>
                                    {"Generate Key"}
                                </Button>
                            </div> */}
                <div className="col-md-12  mb-2 mb-md-0 btnclass">
                  <Button
                    block
                    onClick={(e) => handleLogin(e)}
                    value={"login"}
                    className="btns"
                    style={{
                      padding: "5px 10px",
                      background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                      border: "1px solid #3a3a3a",
                      color: "#ffffff",
                      fontSize: "16px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                      transition: "background 0.3s ease, transform 0.2s ease",
                    }}
                  >
                    <LoginIcon /> {" "}{"Login"}
                  </Button>
                </div>
              </div>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Login;
